import { gql } from "urql";

export const drgRecalculateMutationDoc = gql`
  mutation drgRecalculate($claimId: ID!) {
    drgRecalculate(claimId: $claimId) {
      claim {
        id
        drgStatus
        estimatedOverpaymentCents
        originalGrouping {
          drgCode
          drgDescription
          relativeWeight
          soi
          rom
          ccMcc
        }
        recalculatedGrouping {
          drgCode
          drgDescription
          relativeWeight
          rwDeltaVsBilled
          soi
          rom
          ccMcc
        }
        codes {
          id
          codeKind
          code
          codeDescription
          role
          paymentImpact
          paymentImpactAmount
          poa
          soi
          rom
          claimCodeStatus
          metadata {
            code
            description
            hierarchy
            isBillable
            notes
          }
        }
      }
    }
  }
`;
